
import Footer from "@/components/sections/Footer";
import WorkHero from "@/components/sections/work/WorkHero";
import FightAgainstBlight from "@/components/sections/work/FightAgainstBlight";
import RepresentingGrowers from "@/components/sections/work/RepresentingGrowers";
import FruitLogistica from "@/components/sections/work/FruitLogistica";
import OlieH from "@/components/sections/work/OlieH";

const Work = () => {
  return (
    <div className="min-h-screen bg-white">
      <WorkHero />
      
      <div className="py-16 px-4 md:px-8">
        <div className="max-w-6xl mx-auto space-y-12">
          <FightAgainstBlight />
          <FruitLogistica />
          <OlieH />
        </div>
      </div>

      <RepresentingGrowers />
      <Footer />
    </div>
  );
};

export default Work;
